<label for="ng2FileInput" ng2FileDrop
       class="file-dnd-section label"
       (onFileDrop)="fileSelected($event)"
       [uploader]="uploader">
  <input type="file" [multiple]="multiple" ng2FileSelect id="ng2FileInput" class="d-none" [accept]="acceptedFileType" [uploader]="uploader" (onFileSelected)="fileSelected($event)">
  <span class="btn btn-primary text-capitalize" type="submit">{{ 'global.browseFiles' | translate }}</span>
  <span class="label">{{ 'global.dropFilesLabel' | translate }}</span>
</label>
